/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { v4 as uuidv4 } from 'uuid';
import FormLabel from "./FormLabel";
import { SidebarGlobal } from "./_Sidebar";
import MessageDialog from "./MessageDialog";
import Globals from "../shared/Globals";
import Auth from "../shared/Auth";
import AppActions from "./AppActions";
import Icon from "./Icon";
import { Form, Link } from "react-router-dom";
import { PurchaseOrderGlobal } from "./PurchaseOrders";
import AccountQuickEdit from "./account/AccountQuickEdit";
import Address from "./Address";
import Alert from "./Alert";
import UploadPad from "./UploadPad";
import L from "./Lang";
import Checkout2Modal from "./payment/Checkout2Modal";
import { Pop } from "./PopModal";

class PurchaseOrderView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                lineItems: []
            },
            saving: false,
            accountList: [],
            products: [],
            productsLoaded: null,
            totalQuantity: 0,
            totalPrice: 0,
            loading: this.props.params.id ? true : false
        };

        this.loadProducts = this.loadProducts.bind(this);
        this.load = this.load.bind(this);
        this.searchProducts = this.searchProducts.bind(this);
        this.validate = this.validate.bind(this);
        this.remove = this.remove.bind(this);
    }

    componentDidMount() {
        this.loadAccountList();
        this.loadShippingMethods();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    loadAccountList(noLoadProducts) {
        qreq.get('/api/account/list', j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list) {
                if (j.list.length === 1)
                    this.state.item.accountID = j.list[0].id;
                this.setState({ accountList: j.list, loaded: true });
                if (!noLoadProducts) {
                    setTimeout(() => {
                        this.loadProducts(this.state.item.accountID);
                    }, 100);
                }
                this.change();
            }
        });
    }

    loadShippingMethods = async () => {
        try {
            let j = await qreq.getAsync('/api/shipping-method/list');
            if (j.list) {
                this.setState({ shippingMethods: j.list });
            }
        }
        catch { }
    }

    loadProducts(accountID, noLoad) {
        qreq.post('/api/product/list?accountID=' + (accountID || '0'), {}, j => {
            if (j.list) {
                var products = [];
                var sizes = [];
                j.list.forEach(i => {
                    var product = products.find(k => k.id === i.name);
                    if (!product)
                        products.push({ id: i.name, name: i.name, obj: i, manufacturerName: i.manufacturerName });
                    var size = sizes.find(k => k.id === i.name + '-' + i.productSize);
                    if (!size) {
                        sizes.push({ id: i.id, name: i.productSize, productName: i.name, productID: i.id, units: i.units, totalPrice: i.totalPrice, manufacturerName: i.manufacturerName, sellPrice: i.sellPrice });
                    }
                });
                sizes.sort((a, b) => a.name.localeCompare(b.name));
                this.sizes = sizes;
                this.setState({ products: products, productsLoaded: true });
                if (!noLoad)
                    this.load();
            }
        });
    }

    updateProducts = (accountID) => {
        if (!accountID)
            return;
        accountID = parseInt(accountID);
        if (!this.state.productsLoaded) {
            setTimeout(() => this.updateProducts(accountID), 100);
            return;
        }
        let products = [...this.state.products];
        qreq.post('/api/product/list?accountID=' + (accountID || '0'), {}, j => {
            if (j.list) {
                let lineItems = [...this.state.item.lineItems];
                j.list.forEach(i => {
                    let product = products.find(a => a.id === i.id);
                    if (product) {
                        product.totalPrice = i.totalPrice;
                        product.sellPrice = i.sellPrice;
                        product.units = i.units;
                    }

                    let size = this.sizes.find(a => a.id === i.id);
                    if (size) {
                        size.totalPrice = i.totalPrice;
                        size.sellPrice = i.sellPrice;
                        size.units = i.units;
                    }
                    lineItems.forEach(a => {
                        if (a.productID === i.id) {
                            a.totalPrice = i.totalPrice;
                            a.sellPrice = i.sellPrice;
                            a.units = i.units;
                        }
                    });
                });

                products.forEach(zz => {
                    zz.isDisabled = j.list.find(a => a.id === zz.obj.id) ? false : true;
                });

                this.setState({ products: products, item: { ...this.state.item, lineItems } });
            }
        });

    }

    selectAccount = async (type, id) => {
        if (!id) {
            this.setState({ [type]: null });
            return;
        }
        try {
            let j = await qreq.getAsync('/api/account/get/' + id);
            if (j.item) {
                this.setState({ [type]: j.item });
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.change();
    }


    loadAccounts = (item) => {
        if (item.accountID)
            this.selectAccount('account', item.accountID);
        if (item.distributorAccountID)
            this.selectAccount('distributorAccount', item.distributorAccountID);
        if (item.subDistributorAccountID)
            this.selectAccount('subDistributorAccount', item.subDistributorAccountID);
        if (item.shipToAccountID)
            this.selectAccount('shipToAccount', item.shipToAccountID);
    }

    accountChange = (v) => {
        this.updateProducts(v);
        this.selectAccount('account', v);
        this.checkIfPaymentEnabled();
    }

    load() {
        if (this.props.params.id) {
            qreq.get('/api/purchase-order/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    j.item.lineItems.forEach(i => {
                        i.sizes = [];
                        i.productSizeID = i.productID;
                        this.filterSizes(i, i.productName);
                    });
                    this.state.item = j.item;
                    this.setState({ item: this.state.item });
                    this.change();
                    this.loadAccounts(j.item);
                    this.loadProducts(j.item.accountID, true);
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }

    submit = async (e, send) => {
        e?.preventDefault();

        let item = { ...this.state.item };

        this.setState({ saving: true });


        item.lineItems.forEach(i => {
            var size = this.sizes.find(j => j.id === Number(i.productSizeID));

            if (!size)
                return;

            i.productID = i.productSizeID;
            i.productSize = size.name;
        });

        if (this.state.shippingAccount) {
            item.shippingAccount = { ...this.state.shippingAccount };
            item.shipToAccountID = 0;
        }

        if (!item.distributorAccountID) item.distributorAccountID = 0;
        if (!item.subDistributorAccountID) item.subDistributorAccountID = 0;
        if (!item.shippingAccountID) item.shippingAccountID = 0;

        if (this.state.modify)
            item.sent = true;


        if (send)
            item.sendAction = true;

        qreq.post('/api/purchase-order/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    searchProducts(obj) {

    }

    selectProduct(sel) {
        var obj = {
            key: uuidv4(),
            displayName: sel.obj.productName,
            productName: sel.obj.name,
            manufacturerName: sel.obj.manufacturer,
            totalPrice: sel.obj.totalPrice,
            sellPrice: sel.obj.sellPrice,
            units: sel.obj.units
        };
        this.filterSizes(obj, obj.productName);
        this.addToList(this.state.item.lineItems, obj);
        this.setState({ showCatalogModal: false });
        this.change();
    }

    filterSizes(obj, sel) {
        if (!sel || !this.sizes) {
            obj.sizes = [];
            return;
        }
        var sizes = [];
        this.sizes.forEach(i => {
            if (i.productName === sel)
                sizes.push(i);
        });
        obj.sizes = sizes;
    }

    getObjSize(obj, id) {
        return obj.sizes.find(i => i.id === parseInt(id));
    }

    validate(obj) {
        if (obj.quantity < 1) {
            obj.quantity = 1;
            this.setState({ item: this.state.item });
        }
        this.change();
    }

    _validate = (obj, e) => {
        obj.qty = e.target.value;
        this.validate(obj);
    }

    remove(obj) {
        this.state.item.lineItems.splice(this.state.item.lineItems.indexOf(obj), 1);
        this.setState({ item: this.state.item });
        this.change();
    }

    change = () => {
        let totalQuantity = 0, totalPrice = 0;
        this.state.item.lineItems.forEach(i => {
            let qty = parseInt(i.qty);
            totalQuantity += qty;
            totalPrice += qty * parseFloat(i.totalPrice);
        });
        this.setState({ totalQuantity: totalQuantity, totalPrice: totalPrice, item: { ...this.state.item }, touched: true });
    }

    _changeNotes = (obj, e) => {
        obj.notes = e.target.value;
        this.change();
    }

    changeSize = (obj) => {
        let size = this.getObjSize(obj, obj.productSizeID);
        if (!size) {
            obj.totalPrice = 0;
            obj.sellPrice = 0;
            obj.units = 0;
            this.change();
            return;
        }
        obj.totalPrice = size.totalPrice;
        obj.sellPrice = size.sellPrice;
        obj.units = size.units;
        this.change();
    }

    getSizeForView = (obj) => {
        let size = this.getObjSize(obj, obj.productSizeID);
        return size ? size.name : '';
    }

    _changeSize = (obj, e) => {
        obj.productSizeID = e.target.value;
        this.changeSize(obj);
    }

    getUnitCount = (obj) => {
        return parseInt(obj.qty || 0) * obj.units;
    }

    getAllUnitCount = () => {
        let total = 0;
        this.state.item.lineItems.forEach(i => {
            total += this.getUnitCount(i);
        });
        if (total === 0)
            return '';
        return total;
    }

    modify = () => {
        this.setState({ modify: true, item: { ...this.state.item, sent: false } });
    }

    isCustomCarrier = () => {
        let find = this.state.shippingMethods?.find(i => i.id === parseInt(this.state.item.shippingMethodID));
        if (find && find.carrier === 'CUSTOM')
            return true;
        return false;
    }

    checkIfPaymentEnabled = async () => {
        let account = await this.getAccountAsync(this.state.item.accountID);
        this.setState({ paymentEnabled: account?.isPaymentPortal });
    }

    sendConfirm = async () => {
        Pop.showConfirm(<L>Are you sure you want to send this purchase order?</L>, <L>Send</L>, () => {
            this.submit(null, true);
        });
    }

    pay = (item, e, callback) => {
        this.setState({ showCheckout: true, checkoutCallback: callback, checkoutItem: item });
    }

    getAccountAsync = async (id) => {
        try {
            let j = await qreq.getAsync('/api/account/get/' + id);
            if (j.item)
                return j.item;
        }
        catch (e) {
            console.error(e);
        }
        return null;
    }

    sendPONow = async (item) => {
        item.sending = true;
        try {
            let j = await qreq.postAsync('/api/purchase-order/send', item);
            if (j.errorCode === 0) {
                item.sent = true;
                this.setState({ list: this.state.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        item.sending = false;
    }

    canSend = () => {
        return this.state.item.accountID && this.state.item.shipToAccountID && !this.state.paymentEnabled;
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1>Edit Product</h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<>
            {(!this.state.item.sent || Auth.hasRole('manager')) && <button type="button" className="btn btn-primary" onClick={() => document.getElementById('c-submit').click()}>
                <FontAwesomeIcon icon={fa.faSave} /> <span className="d-none d-md-inline">Save</span>
            </button>}
            {this.state.item.sent && Auth.hasRole('manager') && <button type="button" className="btn btn-secondary" onClick={this.modify}>
                <FontAwesomeIcon icon={fa.faPencil} /> <span className="d-none d-md-inline">Modify</span>
            </button>}
        </>);

        return <div className="container-fluid">
            <Modal show={this.state.showCatalogModal} onHide={() => this.setState({ showCatalogModal: false })} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Product Catalog</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {this.state.products.filter(x => !x.isDisabled).length === 0 ? <Alert>No products available for your account. Please contact the administrators.</Alert>
                            : this.state.products.filter(x => !x.isDisabled).map(i => <div key={i.name} className="col-md-4">
                                <div className="bg-white rounded p-3 text-center drop-shadow">
                                    <div className="my-2">
                                        {i.obj.imageIdent ? <img src={Globals.getStorageURL(i.obj.imageIdent)} alt="" className="img-fluid" /> :
                                            <img src={i.obj && i.obj.productName ? '/img/products/' + i.obj.productName.toLowerCase() + '.png' : ''} alt="" className="img-thumb img-fluid" style={{ height: '100px' }} />}

                                    </div>
                                    <h4>{i.obj.productName}</h4>
                                    <div>{i.obj.manufacturer}</div>
                                    <div className="d-grid gap-2 mt-2">
                                        <button type="button" className="btn btn-primary btn-lg" onClick={() => this.selectProduct(i)}>Select this Product</button>
                                    </div>
                                </div>
                            </div>)}
                    </div>
                </Modal.Body>
            </Modal>

            <Checkout2Modal
                show={this.state.showCheckout}
                onHide={() => this.setState({ showCheckout: false })}
                currentItem={this.state.checkoutItem}
                onSuccess={this.state.checkoutCallback}
            />


            <form onSubmit={this.submit}>
                <h1>Purchase Order {this.state.item.sent && PurchaseOrderGlobal.getStatus(this.state.item)}</h1>
                <Breadcrumb path={[['Purchase Order', '/purchase-order/list'], [this.props.params.id ? this.state.item.iid : 'New']]} />

                <AppActions>
                    {this.canSend() && !this.state.item.sent && <button type="button" className="btn btn-success btn-lg" onClick={() => this.sendConfirm()}>
                        <Icon icon="faPaperPlane" /> Send
                    </button>}
                    {(!this.state.item.sent || (Auth.hasRole('manager') && !this.state.item.completed)) && <button type="submit" className="btn btn-primary btn-lg">
                        <Icon icon="faSave" /> Save
                    </button>}
                </AppActions>

                {Auth.hasRole('master') && this.state.item.confirmed && <div className="alert alert-success">
                    <p>This purchase order has been confirmed.</p>
                    {false && <Link to={'/purchase-order/' + this.state.item.id + '/checkout'} className="btn btn-primary" onClick={this.checkout}>
                        Checkout with Card
                    </Link>}
                </div>}

                <div className="row">
                    {Auth.hasRole('billing-distributor') && <div className="col-lg">
                        <Card title="Billing Account">
                            {!this.state.item.id && this.state.accountList.length === 1 ? <FormLabel model={this.state.accountList[0].name} label="Billing Account" /> :
                                <FormInput model={this.state.item}
                                    name="accountID"
                                    label="Billing *"
                                    labelAsPlaceholder
                                    autoSelect
                                    type="select"
                                    options={this.state.accountList.filter(a => a.passthrough && a.level === 0)}
                                    required
                                    disabled={this.state.item.sent}
                                    onChange={this.accountChange}
                                    onAutoSelect={this.accountChange}
                                />}
                            {this.state.account && <Address item={this.state.account.billingAddress} condensed
                                title="Billing Address" />}
                        </Card>
                    </div>}
                    {Auth.hasRole('distributor') && !(this.state.item.sent && !this.state.item.distributorAccountID) && this.state.accountList?.filter(a => a.passthrough && a.level === 1).length > 0 && <div className="col-lg">
                        <Card title="Distributor Account">
                            {!this.state.item.id && this.state.accountList.length === 1 ? <FormLabel model={this.state.accountList[0].name} label="Distributor Account" /> :
                                <FormInput model={this.state.item}
                                    name="distributorAccountID"
                                    label="Distributor"
                                    labelAsPlaceholder
                                    autoSelect
                                    type="select"
                                    options={this.state.accountList.filter(a => a.passthrough && a.level === 1)}
                                    disabled={this.state.item.sent}
                                    onChange={v => this.selectAccount('distributorAccount', v)}
                                />}
                            {this.state.distributorAccount ? <Address item={this.state.distributorAccount.address} condensed
                                title="Contact Address" />
                                : <small>Do not select if it does not apply.</small>}
                        </Card>
                    </div>}
                </div>
                <div className="row">
                    {Auth.hasRole('sub-distributor') && !(this.state.item.sent && !this.state.item.subDistributorAccountID) && this.state.accountList?.filter(a => a.passthrough && a.level === 2).length > 0 && <div className="col-lg">
                        <Card title="Sub-Distributor Account">
                            {!this.state.item.id && this.state.accountList.length === 1 ? <FormLabel model={this.state.accountList[0].name} label="Distributor Account" /> :
                                <FormInput model={this.state.item}
                                    name="subDistributorAccountID"
                                    label="Sub-Distributor"
                                    labelAsPlaceholder
                                    type="select"
                                    options={this.state.accountList.filter(a => a.passthrough && a.level === 2)}
                                    disabled={this.state.item.sent}
                                    onChange={v => this.selectAccount('subDistributorAccount', v)}
                                />}
                            {this.state.subDistributorAccount ? <Address item={this.state.subDistributorAccount.address} condensed
                                title="Contact Address" />
                                : <small>Do not select if it does not apply.</small>}
                        </Card>
                    </div>}
                    {Auth.hasRole('distribution-recipient') && <div className="col-lg-12">
                        <Card title="Shipping Account">
                            {!this.state.showAddNewShipping && (
                                !this.state.item.id && this.state.accountList.length === 1 ?
                                    <FormLabel model={this.state.accountList[0].name} label="Shipping Account" /> :

                                    <FormInput model={this.state.item}
                                        name="shipToAccountID"
                                        label="Shipping *"
                                        labelAsPlaceholder
                                        type="select"
                                        options={this.state.accountList.filter(a => a.passthrough && a.canReceiveShipping)}
                                        required
                                        disabled={this.state.item.sent}
                                        onChange={v => this.selectAccount('shipToAccount', v)}
                                    />
                            )}
                            {this.state.shipToAccount && <>
                                <div className="row">
                                    <div className="col-md">
                                        <Address item={this.state.shipToAccount.shippingAddress} condensed
                                            title="Shipping Address" />
                                    </div>
                                    <div className="col-md">
                                        {this.state.shipToAccount.contactName && <FormLabel model={this.state.shipToAccount.contactName}
                                            label="Contact Name" />}
                                        {this.state.shipToAccount.phone && <FormLabel model={this.state.shipToAccount.phone}
                                            label="Phone" />}
                                        {this.state.shipToAccount.fedexAccountNumber && <FormLabel model={this.state.shipToAccount.fedexAccountNumber}
                                            label={<>Carrier <span className="text-muted">(FedEx)</span> Account Number</>} />}
                                    </div>
                                </div>
                            </>}

                            {!this.state.item.sent &&
                                (!this.state.showAddNewShipping ? <p>
                                    <span
                                        role="button"
                                        className="text-primary"
                                        onClick={() => this.setState({
                                            shippingAccount: {
                                                address: {},
                                                billingAddress: {},
                                                shippingAddress: {}
                                            }, showAddNewShipping: true
                                        })}>
                                        Add New Shipping Account
                                    </span>
                                </p> : <>
                                    <AccountQuickEdit item={this.state.shippingAccount} />
                                    <p>
                                        <span
                                            role="button"
                                            className="text-primary"
                                            onClick={() => this.setState({ shippingAccount: null, showAddNewShipping: false })}>
                                            Cancel Adding New Shipping Account
                                        </span>
                                    </p>
                                </>)}
                        </Card>
                    </div>}
                </div>

                <div className="row">
                    {this.state.item.sent && Auth.hasRole('manager') && <div className="col-md">
                        <Card title="Approvals">
                            {this.state.item.businessApproved && this.state.item.distributionApproved
                                ? <div className="alert alert-success">Package approved for shipping. {this.state.touched && <u>Don't forget to save!</u>}</div>
                                : <div className="alert alert-warning">Please review the purchase order below and trigger the approval if valid.</div>}
                            {Auth.hasRole('admin') && <FormInput
                                model={this.state.item}
                                name="businessApproved"
                                label="Business Approved"
                                type="switch"
                                onChange={this.change}
                                disabled={this.state.item.businessApproved && this.state.item.distributionApproved}
                            />}
                            {Auth.hasRole('manager') && <FormInput
                                model={this.state.item}
                                name="distributionApproved"
                                label="Distribution Approved"
                                type="switch"
                                onChange={this.change}
                                disabled={this.state.item.businessApproved && this.state.item.distributionApproved}
                            />}
                        </Card>
                        <Card title="File Attachments">
                            <UploadPad
                                item={this.state.item}
                                name="attachments"
                                onUploadBegin={() => this.setState({ uploading: true })}
                                onUploadEnd={() => this.setState({ uploading: false })}
                            />
                        </Card>
                    </div>}
                    <div className="col-md">
                        <Card title="FedEx Shipping Options">
                            {this.state.shippingMethods && <>
                                <FormInput model={this.state.item}
                                    name="shippingMethodID"
                                    label="Shipping Method"
                                    type="select"
                                    options={this.state.shippingMethods.filter(x => !x.isDisabled)}
                                    onChange={this.change}
                                    disabled={this.state.item.shipped}
                                />
                                {this.state.item.shippingMethodID > 0 && <p>
                                    <small className="text-muted">{this.state.shippingMethods.find(i => i.id === parseInt(this.state.item.shippingMethodID))?.description}</small>
                                </p>}
                            </>}

                            {this.isCustomCarrier() && <FormInput model={this.state.item}
                                name="customCarrierName"
                                label="Courier Name"
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped}
                            />}

                            {!this.isCustomCarrier() && !this.state.shipToAccount?.fedexAccountNumber ? <FormInput model={this.state.item}
                                name="carrierAccountNumber"
                                label={<>Carrier <span className="text-muted">(FedEx)</span> Account Number</>}
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped}
                            /> : <FormInput model={this.state.shipToAccount} name="fedexAccountNumber" disabled
                                label={<>Carrier <span className="text-muted">(FedEx)</span> Account Number</>} />}

                            <FormInput model={this.state.item}
                                name="receiverName"
                                label="Receiver Name"
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped}
                            />

                            <FormInput model={this.state.item}
                                name="receiverPhone"
                                label="Receiver Phone"
                                type="text"
                                onChange={this.change}
                                disabled={this.state.item.shipped}
                            />
                        </Card>
                    </div>
                </div>
                {(!Auth.hasRole('billing-distributor') || this.state.item.accountID) ? <Card title="Products">

                    {!this.state.item.sent && <div className="mb-3">
                        <button type="button" className="btn btn-primary btn-lg" onClick={() => this.setState({ showCatalogModal: true })}>
                            <FontAwesomeIcon icon={fa.faPlus} /> Select from Catalog
                        </button>
                    </div>}
                    <div className="d-none d-md-block">
                        <table className="table table-fixed mt-2">
                            <thead>
                                <tr>
                                    <td>Product</td>
                                    <td>Size (cm)</td>
                                    <td>Quantity</td>
                                    {Auth.hasRole('billing-distributor')
                                        && <td>Price/cm<sup>2</sup></td>}
                                    <td>Line/cm<sup>2</sup></td>
                                    {Auth.hasRole('billing-distributor')
                                        && <td>Line Total <span className="text-muted">($)</span></td>}
                                    <td>Notes</td>
                                    <td style={{ width: '100px' }}></td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.item.lineItems.map(obj =>
                                    <tr key={obj.key ? obj.key : obj.id}>
                                        <td>
                                            <div className="text-muted">{obj.manufacturerName}</div>
                                            <div><strong>{obj.displayName}</strong></div>
                                        </td>
                                        <td>
                                            <div className="form-group">

                                                {(!obj.productName || this.state.item.sent) ? this.getSizeForView(obj) : <>
                                                    <label className="form-label">* Size</label>
                                                    <select className="form-select"
                                                        onChange={(e) => this._changeSize(obj, e)}
                                                        disabled={!obj.productName || this.state.item.sent}
                                                        defaultValue={obj.productSizeID}
                                                        required>
                                                        <option>Select Size</option>
                                                        {obj.sizes.map((i, idx) => <option key={idx} value={i.id}>{i.name}</option>)}
                                                    </select>
                                                </>}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="form-group">


                                                {(!obj.productName || this.state.item.sent) ? Globals.formatQuantity(obj.qty) : <>
                                                    <label className="form-label">* Quantity</label>
                                                    <input type="number"
                                                        className="form-control"
                                                        value={obj.qty}
                                                        onChange={(e) => this._validate(obj, e)}
                                                        disabled={!obj.productName || this.state.item.sent}
                                                        placeholder="0"
                                                        required />
                                                </>}
                                            </div>
                                        </td>
                                        {Auth.hasRole('billing-distributor')
                                            && <td>{Globals.formatCurrency(obj.sellPrice)}</td>}
                                        <td>{this.getUnitCount(obj)}</td>
                                        {Auth.hasRole('billing-distributor')
                                            && <td>{Globals.formatCurrency(obj.totalPrice * obj.qty)}</td>}
                                        <td>
                                            <div className="form-group">
                                                <label className="form-label">Notes</label>
                                                {(!obj.productName || this.state.item.sent) ? <input type="text"
                                                    className="form-control"
                                                    onChange={(e) => this._changeNotes(obj, e)}
                                                    disabled={!obj.productName || this.state.item.sent} /> : obj.notes}
                                            </div>
                                        </td>
                                        <td style={{ minWidth: '120px' }}>
                                            {!this.state.item.sent && <button type="button" className="btn btn-danger" onClick={() => this.remove(obj)}><FontAwesomeIcon icon={fa.faTrash} /></button>}
                                        </td>
                                    </tr>)}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={3}></td>
                                    {Auth.hasRole('billing-distributor') && <td></td>}
                                    <td>{this.getAllUnitCount()}</td>
                                    <td colSpan={Auth.hasRole('billing-distributor') ? 3 : 2}>
                                        {Auth.hasRole('billing-distributor')
                                            && <strong>{Globals.formatCurrency(this.state.totalPrice ?? 0)}</strong>}
                                    </td>
                                </tr>
                            </tfoot>

                        </table>
                    </div>
                    <div className="d-block d-md-none">
                        {this.state.item.lineItems.map((obj, idx) => <Card key={idx} title={obj.manufacturerName + ' ' + obj.displayName}>
                            <div className="form-group mb-3">
                                <label className="form-label">* Size</label>
                                <select className="form-select"
                                    onChange={(e) => this._changeSize(obj, e)}
                                    disabled={!obj.productName || this.state.item.sent}
                                    defaultValue={obj.productSizeID}
                                    required>
                                    <option>Select Size</option>
                                    {obj.sizes.map((i, idx) => <option key={idx} value={i.id}>{i.name}</option>)}
                                </select>
                            </div>

                            <div className="form-group mb-3">
                                <label className="form-label">* Quantity</label>
                                <input type="number"
                                    className="form-control"
                                    value={obj.qty}
                                    onChange={(e) => this._validate(obj, e)}
                                    disabled={!obj.productName || this.state.item.sent}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Price/cm<sup>2</sup></label>
                                <input type="text" className="form-control" value={Globals.formatCurrency(obj.sellPrice)} disabled />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Line/cm<sup>2</sup></label>
                                <input type="text" className="form-control" value={this.getUnitCount(obj)} disabled />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Line Total <span className="text-muted">($)</span></label>
                                <input type="text" className="form-control" value={Globals.formatCurrency(obj.totalPrice * obj.qty)} disabled />
                            </div>

                            <div className="form-group mb-3">
                                <label className="form-label">Notes</label>
                                <input type="text"
                                    className="form-control"
                                    onChange={(e) => this._changeNotes(obj, e)}
                                    disabled={!obj.productName || this.state.item.sent}
                                    value={obj.notes}
                                />
                            </div>

                            {!this.state.item.sent && <button type="button" className="btn btn-danger" onClick={() => this.remove(obj)}>
                                <FontAwesomeIcon icon={fa.faTrash} /> Delete
                            </button>}
                        </Card>)}
                    </div>

                </Card> : <Alert>Select a billing account before selecting products.</Alert>}

                {Auth.hasRole('admin') && this.state.item.id && <Card title="Terms and Conditions">
                    <FormInput model={this.state.item}
                        name="terms"
                        label="Terms and Conditions"
                        type="textarea"
                        disabled={this.state.item.shipped && !(this.state.modify && Auth.hasRole('admin'))}
                        onChange={this.change}
                    />
                </Card>}

                <Card title="Additional Information">
                    <FormInput model={this.state.item}
                        name="specialInstructions"
                        label="Special Instructions"
                        type="textarea"
                        placeholder="Special instructions for the order. Can be left blank if none."
                        disabled={(this.state.item.shipped && !(this.state.modify && Auth.hasRole('admin'))) || (this.state.item.sent && !Auth.hasRole('manager'))}
                        onChange={this.change}
                    />
                    {this.state.item.specialInstructions
                        && <small className="text-muted">Special Instructions will be included in the Purchase Order and Packing Slip.</small>}
                </Card>

                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>

                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block">Save</button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}>Cancel and Go Back</button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParams(PurchaseOrderView);